import type { RouteObject } from "react-router";
import { AgenturNachrichten } from "./AgenturNachrichten";
import { AgenturBenachrichtigungen, CreatorBenachrichtigungen } from "./Benachrichtigungen";
import { CreatorNachrichten, CreatorScoped } from "./CreatorNachrichten";

/**
 * Nachrichten (Chat) und Benachrichtigungen (Glocke), Agentur und Creator. Gruppe „Nachrichten“.
 * Sprungziele: /agentur/nachrichten/<creator> öffnet den Verlauf mit diesem Creator (ein Weg mit optionalem Teil,
 * damit Suche und Filter beim Wechsel der Unterhaltung stehen bleiben). Der Zähler für die Glocke steht in ./unread.ts.
 */
export const nachrichtenAgenturRoutes: RouteObject[] = [
  { path: "nachrichten/:talentId?", element: <AgenturNachrichten /> },
  { path: "benachrichtigungen", element: <AgenturBenachrichtigungen /> },
];

export const nachrichtenCreatorRoutes: RouteObject[] = [
  { path: "nachrichten", element: <CreatorScoped page={CreatorNachrichten} /> },
  { path: "benachrichtigungen", element: <CreatorScoped page={CreatorBenachrichtigungen} /> },
];
